import { useQuery, useMutation } from '@tanstack/react-query';

const apiUrl = process.env.REACT_APP_API_URL;


export const fetchAllDoctor = async () => {
  const response = await fetch(`${apiUrl}/api/all_medicos`);
  if (!response.ok) {
    throw new Error('Error fetching doctors');
  }
  return response.json();
};
